var map = {
	"./auth.js": "cS9E",
	"./evaluations.js": "DJez",
	"./isco.js": "84rr",
	"./lang.js": "ja3g",
	"./languages.js": "0D3u",
	"./nationalities.js": "3px1",
	"./organizations.js": "IATh",
	"./roles.js": "3EpB",
	"./users.js": "MdEj"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "YVPZ";


//////////////////
// WEBPACK FOOTER
// ./resources/js/store/modules nonrecursive .*\.js$
// module id = YVPZ
// module chunks = 97